import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Icon,
  Link,
  Tooltip,
  Select,
  Banner,
  Layout,
  InlineGrid,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import parse from "html-react-parser";

import {
  accessAddPages,
  accessAddBlogs,
  accessViewSections,
  accessEditBlogs,
  accessEditPages,
  accessViewPages,
} from "../../Helpers";
import {
  ArrowUpIcon,
  ArrowDownIcon,
  AlertCircleIcon,
  InfoMinor,
  PinIcon,
  PinFilledIcon,
} from "@shopify/polaris-icons";
const Pages = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddUser = () => {
    navigate("/admin/settings/users-and-permissions/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[
            { label: "ID", value: "id" },
            { label: "Name", value: "name" },
            { label: "Email", value: "email" },
            { label: "Phone Number", value: "phone_number" },
          ]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage}></img>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };

  const handleEdit = (id) => {
    if (props?.type === "careers") {
      navigate(`/admin/${props.type}/${id}`);
    } else {
      ((props.type === "pages" && accessEditPages()) ||
        (props.type === "blogs" && accessEditBlogs())) &&
        navigate(`/admin/${props.type}/${id}`);
    }
  };

  const [isSaving, setIsSaving] = useState(false);
  const handleSections = (id) => {
    navigate(`/admin/${props.type}/${id}/sections`);
  };
  const [isWebsiteProtected, setIsWebsiteProtected] = useState(false);
  const [channels, setChannels] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState("");
  const handleSelectChangeChannel = (value) => {
    setSelectedChannel(value);
  };
  const handleUp = (e) => {
    const bodyObj = {
      direction: "up",
    };
    axios
      .post(`/blogs/${e.currentTarget.id}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const handleDown = (e) => {
    const bodyObj = {
      direction: "down",
    };
    axios
      .post(`/blogs/${e.currentTarget.id}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const [clickedTag, setClickedTag] = useState("All");

  const handlePinPage = (id, isPinned) => {
    const bodyObj = { is_pinned: isPinned ? 0 : 1 };
    axios
      .post(`pages/${id}/pin`, bodyObj)
      .then((result) => {
        setTs(+new Date());
      })
      .catch((err) => console.log(""));
  };
  useEffect(() => {
    axios
      .get(`settings/password-protection`)
      .then((result) => {
        result?.data?.data?.password_restriction && setIsWebsiteProtected(true);
      })
      .catch((err) => console.log(""));
  }, []);
  const [tags, setTags] = useState(["All"]);

  useEffect(() => {
    setTags(["All"]);
    axios
      .get(`${props.type}-tags`)
      .then((result) => {
        console.log("pages=", result.data.data);
        setTags((currentTags) => currentTags.concat(result.data.data));
        // setTags(result.data.data);
      })
      .catch((err) => console.log(""));
  }, [location.pathname]);

  useEffect(() => {
    fetchData();
  }, [
    page,
    availability,
    queryValue,
    ts,
    props,
    selectedChannel,
    clickedTag,
    location.pathname,
    props?.pageKey,
  ]);

  async function fetchData() {
    let responsePages = "";
    let responseChannels = "";
    if (!channels.length) {
      try {
        responseChannels = await axios.get(`channels`);
        let array = [{ label: "All", value: "all" }];
        for (var i = 0; i < responseChannels.data.data.data.length; i++) {
          let item = responseChannels.data.data.data[i];
          array.push({ label: item.name, value: String(item.id) });
        }
        setChannels(array);
      } catch (error) {
        console.log(error);
      }
    }
    try {
      responsePages = await axios.get(
        `/${props.type}?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${
          queryValue
            ? `&filter[${
                availability === "" ? "title" : availability
              }]=${queryValue}`
            : ""
        }${
          selectedChannel !== "" && selectedChannel !== "all"
            ? `&filter[channels.id]=${selectedChannel}`
            : ""
        }${
          clickedTag !== "" && clickedTag !== "All"
            ? `&filter[tags]=${clickedTag}`
            : ""
        }`
      );
      setPageObject({
        ...pageObject,
        tableItems: responsePages.data.data.data.map((item, index) => [
          <div
            style={{ cursor: "pointer" }}
            onClick={() => handlePinPage(item.id, item.is_pinned)}
          >
            <Icon source={item.is_pinned ? PinFilledIcon : PinIcon} />
          </div>,

          <div className="row_click2">
            {item?.title ? (
              <div className="rowDiv">
                <Link monochrome onClick={() => handleEdit(item.id)}>
                  {item.title["en"]}
                </Link>
                {item?.instructions ? (
                  <div style={{ cursor: "pointer", marginLeft: "1rem" }}>
                    <Tooltip content={parse(item?.instructions)}>
                      <Icon source={AlertCircleIcon} color="subdued" />
                    </Tooltip>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </div>,
          // <div className="row_click2">{item?.alias ? item?.alias : ""}</div>,
          <div className="row_click2">
            <Badge tone={item.is_active ? "success" : "info"}>
              {item.is_active ? "Active" : "Draft"}
            </Badge>
          </div>,
          // <div className="row_click2">
          //   {item?.instructions ? (
          //     <div style={{ cursor: "pointer" }}>
          //       <Tooltip content={parse(item?.instructions)}>
          //         <Icon source={AlertCircleIcon} color="subdued" />
          //       </Tooltip>
          //     </div>
          //   ) : (
          //     ""
          //   )}
          // </div>,
          <div className="me-3">
            <ButtonGroup>
              {props.type === "blogs" && (
                <Button id={String(item.id)} onClick={(e) => handleUp(e)}>
                  <Icon source={ArrowUpIcon}></Icon>
                </Button>
              )}
              {props.type === "blogs" && (
                <Button id={String(item.id)} onClick={(e) => handleDown(e)}>
                  <Icon source={ArrowDownIcon}></Icon>
                </Button>
              )}

              <Button
                variant="primary"
                onClick={() => handleSections(item.id)}
                disabled={!accessViewSections()}
              >
                Sections
              </Button>
            </ButtonGroup>
          </div>,
        ]),
        isLoading: false,
        isListEmpty: !responsePages.data.data.data.length ? true : false,
        tableTotalPages: responsePages.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This user has been successfully verified"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const refId = useRef(null);
  const [activeVerify, setActiveVerify] = useState(false);
  const handleChangeModalVerify = useCallback((activeVerify) => {
    setActiveVerify(!activeVerify);
    setIsSaving(false);
  }, []);
  const handleYesVerify = () => {
    setIsSaving(true);
    axios
      .post(`/app/users/${refId.current}/verify`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveVerify(!activeVerify);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  return (
    accessViewPages() && (
      <Page
        title={props.title}
        // fullWidth
        primaryAction={
          <Button
            variant="primary"
            onClick={() => navigate(`/admin/${props.type}/new`)}
            disabled={
              (props.type === "pages" && !accessAddPages()) ||
              (props.type === "blogs" && !accessAddBlogs())
            }
          >
            {props.button}
          </Button>
        }
      >
        <FormLayout>
          {isWebsiteProtected && (
            <Banner
              title="Website access is restricted"
              // action={{ content: "Edit address" }}
              status="warning"
            >
              While your website is in development, only visitors with the
              password can access it.
            </Banner>
          )}

          <Card padding="0">
            <div className="boxTags">
              {tags?.length
                ? tags.map((element, index) => {
                    return (
                      <div
                        key={index}
                        className={`buttonTags ${
                          clickedTag === element ? "clickedTag" : ""
                        }`}
                        onClick={() => {
                          setClickedTag(element);
                        }}
                      >
                        {element}
                      </div>
                    );
                  })
                : null}
            </div>
            {loadingMarkup}
            {/* <div className="pt-3 ps-3 pe-3">
              <Select
                label="Filter by Channel: "
                labelInline
                options={channels}
                onChange={handleSelectChangeChannel}
                value={selectedChannel}
              />
            </div> */}
            {/* <Layout>
              <Layout.Section> */}
            <InlineGrid columns={["twoThirds", "oneThird"]} gap="200">
              <Filters
                queryValue={queryValue}
                queryPlaceholder="Search..."
                filters={filters}
                appliedFilters={appliedFilters}
                onQueryChange={handleFiltersQueryChange}
                onQueryClear={handleQueryValueRemove}
                onClearAll={handleFiltersClearAll}
              />
              <div style={{ marginTop: "0.4rem", marginRight: "0.4rem" }}>
                <Select
                  label="Filter by Channel:"
                  labelInline
                  options={channels}
                  onChange={handleSelectChangeChannel}
                  value={selectedChannel}
                />
              </div>
            </InlineGrid>

            <DataTable
              columnContentTypes={["text", "text", "text", "text"]}
              headings={[
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
                <Text variant="bodyMd" as="p" fontWeight="medium">
                  Title
                </Text>,
                // <Text variant="bodyMd" as="p" fontWeight="medium">
                //   Alias
                // </Text>,
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
                // <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
              ]}
              rows={pageObject.tableItems}
              verticalAlign="middle"
              increasedTableDensity
              footerContent={
                pageObject.tableItems?.length &&
                `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
              }
              hasZebraStripingOnData
              // truncate
            />
            {emtyState}
            {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
              <div
                style={{
                  paddingTop: "10px",
                  textAlign: "center",
                  paddingBottom: "10px",
                }}
              >
                <Pagination
                  variant="outlined"
                  count={Math.ceil(pageObject.tableTotalPages / perPage)}
                  page={page}
                  onChange={handleChangePage}
                />
                {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
              </div>
            )}

            <Modal
              open={activeVerify}
              onClose={handleChangeModalVerify}
              title="Verify User"
              primaryAction={{
                content: "Yes",
                onAction: handleYesVerify,
                loading: isSaving,
              }}
              secondaryActions={[
                {
                  content: "No",
                  loading: isSaving,
                  onAction: handleChangeModalVerify,
                },
              ]}
            >
              <Modal.Section>
                <Text>
                  <p>Are you sure you want to ?</p>
                </Text>
              </Modal.Section>
            </Modal>
            {toastMarkup}
          </Card>
        </FormLayout>
      </Page>
    )
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default Pages;
